'use strict';var _desc,_value,_class;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const Formatters=require('../../../../../../../dist-es6/client/formatters');
const ErrorMessages=require('../../../../../../../dist-es6/client/errorMessages');
const SocketResponse=require('../../../../../../../dist-es6/client/dtos/socketResponse');
const{HandleUncaughtErrors:HandleUncaughtErrors}=require('../../../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations;
const BaseController=require('../../../../../../../dist-es6/client/angularCommon/baseController');
const BaseControllerBackedDirective=require('../../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

PairingDateSelectorDirective=function(_BaseControllerBacked){_inherits(PairingDateSelectorDirective,_BaseControllerBacked);function PairingDateSelectorDirective(){_classCallCheck(this,PairingDateSelectorDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(PairingDateSelectorDirective,[{key:'templateUrl',get:function()
{return'/templates/features/emirates/emiratesDashboard/components/pairingDateSelectorDirective/pairingDateSelectorTemplate'}},{key:'objectBindings',get:function()

{return['flightOrPairingIdSelection','pairingDate','crewType']}},{key:'controller',get:function()

{return PairingDateSelectorController}}]);return PairingDateSelectorDirective}(BaseControllerBackedDirective);


const ControllerDefaults={
flightOrPairingIdSelection:null,
availablePairingDateResults:null,
selectedResult:null};let


PairingDateSelectorController=(_class=function(_BaseController){_inherits(PairingDateSelectorController,_BaseController);
function PairingDateSelectorController($scope,$timeout,socketService,dateService,timeZoneService,uncaughtErrorHandler){_classCallCheck(this,PairingDateSelectorController);var _this2=_possibleConstructorReturn(this,
_BaseController.call(this,uncaughtErrorHandler,$timeout,$scope));

_this2._$scope=$scope;
_this2._$timeout=$timeout;
_this2._socketService=socketService;
_this2._dateService=dateService;
_this2._timeZoneService=timeZoneService;

_this2.localTimeZone=_this2._timeZoneService.localTimeZone;

_.defaults(_this2,ControllerDefaults);

_this2._debouncedUpdatePairingDates=_.debounce(function(){return _this2._updateAvailablePairingDates(_this2.flightOrPairingIdSelection)},500);

_this2._safeWatch('flightOrPairingIdSelection',function(){return _this2._debouncedUpdatePairingDates()});
_this2._safeWatch('selectedResult',function(){
_this2._pairingDate=_.get(_this2,'selectedResult.date',null);
_this2._crewType=_.get(_this2,'selectedResult.crewType',null);
});return _this2;
}PairingDateSelectorController.prototype.
































_updateAvailablePairingDates=function(){var ref=_asyncToGenerator(function*(flightOrPairingIdSelection){var _this3=this;
const fromDate=this._dateService.now();

if(this._lastFlightOrPairingIdSelection===flightOrPairingIdSelection&&this._lastFromDate.getTime()===fromDate.getTime()){
return;
}

const availablePairingDateResults=_.sortBy((yield this._getAvailablePairingDatesFor(flightOrPairingIdSelection,fromDate)),['date']);

availablePairingDateResults.forEach(function(r){
_.assign(r,{
dayAndMonthInTimeZone:Formatters.monthAndDayInTimeZone(r.startTime,_this3.localTimeZone,{fullMonth:!0,dayFirst:!0}),
timeAndDayOfWeekInTimeZone:`${Formatters.timeInLocale(r.startTime,_this3.localTimeZone,!1,!0)} ${Formatters.dayOfWeekInTimeZone(r.startTime,_this3.localTimeZone).toUpperCase()}`});

});

this._$timeout(function(){
_this3.availablePairingDateResults=availablePairingDateResults;
_this3.selectedResult=_.first(availablePairingDateResults);
_this3._lastFlightOrPairingIdSelection=flightOrPairingIdSelection;
_this3._lastFromDate=fromDate;
});
});function _updateAvailablePairingDates(flightOrPairingIdSelection){return ref.apply(this,arguments)}return _updateAvailablePairingDates}();PairingDateSelectorController.prototype.


_getAvailablePairingDatesFor=function(){var ref=_asyncToGenerator(function*(flightOrPairingIdSelection,fromDate){
if(!flightOrPairingIdSelection){
return null;
}

const{pairingId:pairingId,flightNumber:flightNumber}=flightOrPairingIdSelection;
const socketResponse=yield this._socketService.sendAndWaitForResponse('GetPairingDatesById',{pairingId:pairingId,flightNumber:flightNumber,fromDate:fromDate});

if(!SocketResponse.succeeded(socketResponse)){
this.isErrored=!0;
this._notificationService.displayNotification(ErrorMessages.OopsTryAgain,'error');
return[];
}

if(socketResponse.body.pairingId===pairingId&&socketResponse.body.flightNumber===flightNumber){
return socketResponse.body.results;
}

return[];
});function _getAvailablePairingDatesFor(flightOrPairingIdSelection,fromDate){return ref.apply(this,arguments)}return _getAvailablePairingDatesFor}();_createClass(PairingDateSelectorController,[{key:'pairingDate',get:function(){return this._pairingDate||null},set:function(pairingDate){}},{key:'crewType',get:function(){return this._crewType||null},set:function(crewType){}},{key:'currentPlaceholderMessage',get:function(){if(this.flightOrPairingIdSelection){if(!this._lastFlightOrPairingIdSelection){return'Loading available dates...'}if(this.availablePairingDateResults.length===0){return'No results available'}}return'Select Departure Time'}}]);return PairingDateSelectorController}(BaseController),(_applyDecoratedDescriptor(_class.prototype,'_updateAvailablePairingDates',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_updateAvailablePairingDates'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_getAvailablePairingDatesFor',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_getAvailablePairingDatesFor'),_class.prototype)),_class);


module.exports=PairingDateSelectorDirective;
//# sourceMappingURL=pairingDateSelectorDirective.js.map
